import React from 'react';
import { SxChips } from '../sxChips';

interface ISxEmailsProps {
  emails: string[];
  setEmails: (emails: string[]) => void;
  maxAllowed: number;
  withReadOnly?: boolean;
  disabled?: boolean;
}

interface IState {
  errorMessage?: string;
}

export class SxEmailTags extends React.Component<ISxEmailsProps, IState> {
  constructor(props: ISxEmailsProps) {
    super(props);
    this.state = {
      errorMessage: undefined
    };
    this.validateEmail = this.validateEmail.bind(this);
  }

  componentDidMount(): void {
    this.setState({ errorMessage: undefined });
  }

  componentDidUpdate(): void {
    if (this.state.errorMessage) {
      setTimeout(() => this.setState({ errorMessage: undefined }), 3000);
    }
  }

  private validateEmail(emails: string[]) {
    const regexEmail = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    for (const email of emails) {
      if (!regexEmail.test(email)) {
        this.setState({ errorMessage: 'Invalid email' });
        return false;
      }
    }
    const emailsToCompare = emails.map((email) => email.toLowerCase());
    const duplicatesFound = emailsToCompare.some((email, index) => emailsToCompare.indexOf(email) !== index);
    if (duplicatesFound) {
      this.setState({ errorMessage: 'Duplicated email' });
      return false;
    }
    this.setState({ errorMessage: undefined });
    return true;
  }

  render(): JSX.Element {
    const { emails, setEmails, maxAllowed, disabled, withReadOnly = false } = this.props;

    return <SxChips
      values={emails}
      setValues={setEmails}
      withReadOnly={withReadOnly}
      maxValuesAllowed={maxAllowed}
      verifyValues={this.validateEmail}
      errorMessage={this.state.errorMessage}
      disabled={disabled}
      tooltipMessage="The main billing contact email cannot be removed. Update your billing information to change this email."
    />;
  }
}
